<template>
  <div class="select-container">
    <VideoFileSelect
      :videoFileId="videoFileId"
      :channelId="props.channelId"
      @change="handleSelectionChange"
    />
    <div v-if="videoFileId" class="action-buttons">
      <button class="action-button view" @click="handleView">
        <font-awesome-icon icon="eye" />
      </button>
      <button v-if="isSuperuser()" class="action-button edit" @click="handleEdit">
        <font-awesome-icon icon="edit" />
      </button>
      <button class="action-button delete" @click="handleDelete">
        <font-awesome-icon icon="trash" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineModel } from 'vue';
import { useRouter } from 'vue-router';
import { isSuperuser } from '@/scripts/permissions';
import { FontAwesomeIcon } from '@/scripts/icons';
import VideoFileSelect from './VideoFileSelect.vue';

const videoFileId = defineModel({ type: String });
const router = useRouter();

const props = defineProps({
  channelId: {
    type: String,
    required: true
  }
});

const handleSelectionChange = (newVideoFileId) => {
  videoFileId.value = newVideoFileId;
};

const handleView = () => {
  if (videoFileId.value) {
    router.push(`/videofiles/${videoFileId.value}`);
  }
};

const handleEdit = () => {
  if (videoFileId.value) {
    router.push(`/admin/videofiles/${videoFileId.value}/edit`);
  }
};

const handleDelete = () => {
  videoFileId.value = null;
};
</script>

<style scoped>
@import '@/styles/file-upload.css';
@import '@/styles/file-select.css';
</style>
